import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ContractService } from "../../../../auth/service/contract.service";
import { CitiesService } from "../../../../auth/service/cities.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpClient, HttpRequest } from "@angular/common/http";
import { locale as italian } from "../../../../i18n/it";
import { Collaborator } from "../form-add-collaborator/form-add-collaborator.component";
import * as moment from "moment";
import { UserFigureService } from "../../../../auth/service/user-figure.service";
import { CollaboratorsService } from "../../collaborators.service";
import nationsWithCodes from "app/auth/models/nations-with-codes";
import { IProvider } from "app/modules/providers/models/providers";
import { ProvidersService } from "app/modules/providers/providers.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-form-edit-collaborator",
  templateUrl: "./form-edit-collaborator.component.html",
  styleUrls: ["./form-edit-collaborator.component.scss"],
})
export class FormEditCollaboratorComponent implements OnInit {

  public formGroup: FormGroup;
  public contentHeader: IContentHeader;
  public activeTab: string = "masterdata";
  public new_skill: string;
  public fileName: string = null;
  public typeCollaborator: Array<string> = ["Stagista", "Partita iva", "Prestazione occasionale", "Da fornitore"];
  public userList: any = [];
  public uploadErrors: any[] = [];
  public isUploaded: number = 0;
  public files_list: any[] = [];
  public files_list_obj: any[] = [];
  public currentCollaboratorHash: string = null;
  public currentCollaborator: any = null;
  public min_birthdate: any = moment().subtract(18, "year").format("YYYY-MM-DD");
  public today: any = moment().format("YYYY-MM-DD");
  public nationsWithCodes: { name: string; code: string }[] = nationsWithCodes;
  public isCopingResidence: boolean = false;
  public providers: IProvider[] = [];

  constructor(
    public _authenticationService: AuthenticationService,
    private _userService: UserService,
    public _utilService: UtilsService,
    private _formBuilder: FormBuilder,
    private _changeDetectorRef: ChangeDetectorRef,
    public _contractService: ContractService,
    public _citiesService: CitiesService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    public _modalService: NgbModal,
    public _httpClient: HttpClient,
    public _userFigureService: UserFigureService,
    public _collaboratorsService: CollaboratorsService,
    public _providersService: ProvidersService,
  ) {
    this._utilService.disableAutoHideLoading();
    this._activatedRoute.params.subscribe(async (params) => {
      this.currentCollaboratorHash = params.hash;
    });
    this.contentHeader = {
      headerTitle: italian.data.EDIT_COLLABORATOR,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.USERS,
            isLink: false,
          },
          {
            name: italian.data.TITLES.USERS_TYPES.collaborator,
            isLink: true,
            link: "/dashboard/collaborators/list",
          },
          {
            name: italian.data.EDIT_COLLABORATOR,
            isLink: false,
          },
        ],
      },
    };

    this.formGroup = this._formBuilder.group({
      firstname: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      lastname: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      phone: new FormControl(null, [Validators.required, Validators.minLength(9), Validators.maxLength(255), Validators.pattern("[0-9, +]+")]),
      private_email: new FormControl(null, [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"), Validators.email]),
      type: new FormControl("Stagista", [Validators.required]),
      fiscalcode: new FormControl(null, [Validators.required, Validators.minLength(16), Validators.maxLength(16)]),
      email: new FormControl(null, [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"), Validators.email]),
      business_name: new FormControl(null),
      figure_id: new FormControl(null, [Validators.required]),
      vat_number: new FormControl(null),
      sex: new FormControl("m"),
      badge_number: new FormControl(null, [Validators.maxLength(5), Validators.minLength(1)]),
      birthday: new FormControl(null),
      unique_code: new FormControl(null),
      start_date: new FormControl(null, [Validators.required]),
      end_date: new FormControl(null, [Validators.required]),
      pec: new FormControl(null, [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"), Validators.email]),
      street: new FormControl(null),
      provider_id: new FormControl(null),
      zipcode: new FormControl(null, [Validators.minLength(5), Validators.maxLength(5), Validators.pattern("[0-9]+")]),
      city_id: new FormControl(null),
      province_id: new FormControl(null),
      country: new FormControl(null),
      external: new FormControl(false),
      billing_street: new FormControl(null),
      billing_zipcode: new FormControl(null),
      billing_city: new FormControl(null),
      billing_province: new FormControl(null),
      billing_country: new FormControl(null),
      billing_external: new FormControl(false),
      tutor_hash: new FormControl(null, [Validators.required]),
      total_daily: new FormControl(0, [Validators.required]),
      note: new FormControl(null),
      send_welcome_email: new FormControl(null),
    });
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("edit_collaborator")) {
      await this._router.navigateByUrl("dashboard/main");
    }
    await this.loadUserData();
  }

  async loadUserData() {
    this.userList = await this._userService.getList("employee");
    this.providers = await this._providersService.getList();

    this.currentCollaborator = await this._collaboratorsService.getCollaborator(this.currentCollaboratorHash).catch(async () => {
      await this._utilService.showSWALError({ text: "NOT_FOUND_USER" });
      await this._router.navigateByUrl("/dashboard/collaborators/list");
      return false;
    });
    this.contentHeader.headerTitle = this.currentCollaborator.business_name ? this.currentCollaborator.business_name : this.currentCollaborator.complete_name;
    if (this.currentCollaborator.contract_attachments && this.currentCollaborator.contract_attachments.length > 0) {
      this.currentCollaborator.contract_attachments.map((contract_attachments) => {
        contract_attachments.filename = contract_attachments.url.split("/")[2].replace(".pdf", "");
      });
    }
    const residence: any = this.currentCollaborator?.addresses?.find((c) => c.label === "residenza");
    const billing: any = this.currentCollaborator?.addresses?.find((c) => c.label === "fatturazione");

    const typeLabel = {
      collaborator: "Partita iva",
      stage: "Stagista",
      "by-provider": "Da fornitore",
      occasional: "Prestazione occasionale",
    };

    this.formGroup.patchValue({
      firstname: this.currentCollaborator.firstname,
      lastname: this.currentCollaborator.lastname,
      phone: this.currentCollaborator.phone,
      private_email: this.currentCollaborator.private_email,
      type: typeLabel[this.currentCollaborator.type_code],
      fiscalcode: this.currentCollaborator.fiscalcode,
      email: this.currentCollaborator.email,
      business_name: this.currentCollaborator.business_name,
      provider_id: this.currentCollaborator.provider_id,
      sex: this.currentCollaborator.sex,
      badge_number: this.currentCollaborator.badge_number,
      birthday: this.currentCollaborator.birthday,
      start_date: this.currentCollaborator.contract.start_date,
      end_date: this.currentCollaborator.contract.end_date,
      figure_id: this.currentCollaborator.figure_id,
      vat_number: this.currentCollaborator.vat_number,
      unique_code: this.currentCollaborator.unique_code,
      pec: this.currentCollaborator.pec,
      street: residence?.street,
      zipcode: residence?.zipcode,
      city_id: residence?.city_id,
      province_id: residence?.province_id,
      country: residence?.country ? residence?.country : null,
      external: residence?.country ? true : false,
      billing_street: billing?.street,
      billing_zipcode: billing?.zipcode,
      billing_city: billing?.city_id,
      billing_province: billing?.province_id,
      billing_country: billing?.country ? billing?.country : null,
      billing_external: billing?.country ? true : false,
      tutor_hash: this.currentCollaborator.contract.tutor_hash,
      total_daily: this.currentCollaborator.contract.total_daily ? this._utilService.addDotsToNumber(this.currentCollaborator.contract.total_daily) : null,
      note: null,
    });
    //Controllo se ci sia una sede estera e nel caso aggiusto i validatori
    if (this.formGroup.value.external) {
      this.manageExternalSiteResidence();
    }
    if (this.formGroup.value.billing_external) {
      this.manageExternalSiteBilling();
    }
    this.changeTypeUser(this.formGroup.value.type, false);
    this._utilService.hideLoading();
  }

  setAutoProvince(address_label: string = "Residence") {
    if (address_label === "Residence") {
      const cityValue: number = this.formGroup.get("city_id").value;
      if (cityValue > 0) {
        const cityObj: any = this._citiesService.list.find((city: any) => city.id === cityValue);
        const province = this._citiesService.list.find((city: any) => city.initials === cityObj.initials && city.is_main === 1);
        this.formGroup.patchValue({ province_id: province.id });
      }
    } else {
      const cityValue: number = this.formGroup.get("billing_city").value;
      if (cityValue > 0) {
        const cityObj: any = this._citiesService.list.find((city: any) => city.id === cityValue);
        const province = this._citiesService.list.find((city: any) => city.initials === cityObj.initials && city.is_main === 1);
        this.formGroup.patchValue({ billing_province: province.id });
      }
    }
  }

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
    this._changeDetectorRef.detectChanges();
  }

  changeTypeUser(value: string, reset: boolean = true) {
    if (reset) {
      /*Resettiamo alcuni campi*/
      this.formGroup.patchValue({
        vat_number: null,
        pec: null,
        business_name: null,
        unique_code: null,
        billing_street: null,
        billing_zipcode: null,
        billing_city: null,
        billing_province: null,
        badge_number: null,
        provider_id: null,
        tutor_hash: null,
        send_welcome_email: null,
      });
    }

    //Nel caso siano stati resettati da fornitore
    this.formGroup.controls.provider_id.clearValidators();
    this.formGroup.controls.phone.setValidators([Validators.required]);
    this.formGroup.controls.phone.setValidators([Validators.minLength(9)]);
    this.formGroup.controls.phone.setValidators([Validators.maxLength(255)]);
    this.formGroup.controls.phone.setValidators([Validators.pattern("[0-9, +]+")]);

    if (value === "Stagista" || value === "Prestazione occasionale") {
      //Clear Validators
      this.formGroup.controls.vat_number.clearValidators();
      //Set Validators
      this.formGroup.controls.fiscalcode.setValidators([Validators.required, Validators.minLength(16), Validators.maxLength(16)]);
      this.formGroup.controls.tutor_hash.setValidators([Validators.required]);
    } else {
      if (value === "Partita iva") {
        //Clear Validators
        this.formGroup.controls.fiscalcode.clearValidators();
        this.formGroup.controls.tutor_hash.clearValidators();
        //Set Validators
        this.formGroup.controls.vat_number.setValidators([Validators.required, Validators.minLength(11), Validators.maxLength(11)]);
      }
      if (value === "Da fornitore") {
        this.formGroup.controls.vat_number.clearValidators();
        this.formGroup.controls.fiscalcode.clearValidators();
        this.formGroup.controls.tutor_hash.clearValidators();
        this.formGroup.controls.provider_id.setValidators([Validators.required]);
      }
    }
    //update
    this.formGroup.controls.vat_number.updateValueAndValidity();
    this.formGroup.controls.tutor_hash.updateValueAndValidity();
    this.formGroup.controls.fiscalcode.updateValueAndValidity();
    this.formGroup.controls.provider_id.updateValueAndValidity();
    this.formGroup.controls.phone.updateValueAndValidity();
  }

  fieldHasErrors(field_name: string): boolean {
    return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
  }

  formatCurrentRal() {
    this.formGroup.patchValue({
      total_daily: this._utilService.addDotsToNumber(this.formGroup.value.total_daily),
    });
  }

  async addFileToList(files: any) {
    // creo una variabile dalla lista attuale
    let updatedList: any[] = this.files_list_obj.filter((item: any) => item.name !== "");
    // ciclo tutti i files inviati
    for (let file of files) {
      // controllo le dimensioni
      if (file.size > 10000000) {
        await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      // aggiungo i files
      this.files_list.push(file);

      // aggiungo alla lista
      updatedList.push({
        name: file.name,
        size: this._utilService.formatBytes(file.size),
        status: 0,
      });
    }
    // aggiorno variabile della pagina
    this.files_list_obj = updatedList;
  }

  uploadFiles() {
    this.isUploaded = 1;
    this.files_list.map((file: File, index: number) => {
      const formData: FormData = new FormData();
      formData.append("file", file);

      const req: any = new HttpRequest("PUT", `/collaborator/contract-attachment/${this.currentCollaboratorHash}`, formData);

      this.files_list_obj[index].status = 1;

      return this._httpClient
        .request(req)
        .toPromise()
        .then(async () => {
          this.files_list_obj[index].status = 2;
          await this.loadUserData();
          this.resetFilesList();
        })
        .catch((err: any) => {
          this.files_list_obj[index].status = 3;
          this.uploadErrors.push({
            filename: this.files_list_obj[index].name,
            error: err.toUpperCase().replace(/\s/gi, "_"),
          });
        });
    });
  }

  resetFilesList() {
    this.files_list_obj = [];
    this.files_list = [];
  }

  removeFileFromList(index: any) {
    this.files_list_obj = this.files_list_obj.filter((item: any, i: number) => i !== index);
    this.files_list = this.files_list.filter((item: any, i: number) => i !== index);
  }

  async copyResidence() {
    //Resetto i valori
    this.formGroup.patchValue({
      billing_street: null,
      billing_zipcode: null,
      billing_city: null,
      billing_province: null,
      billing_country: null,
    });

    this.formGroup.patchValue({
      billing_street: this.formGroup.value.street,
      billing_zipcode: this.formGroup.value.zipcode,
      billing_city: this.formGroup.value.city_id,
      billing_province: this.formGroup.value.province_id,
      billing_country: this.formGroup.value.country,
      billing_external: this.formGroup.value.external,
    });

    this.manageExternalSiteBilling();
  }

  manageExternalSiteBilling() {
    this.isCopingResidence = false;
    if (this.formGroup.value.billing_external) {
      this.formGroup.patchValue({
        billing_province: null,
        billing_city: null,
        billing_zipcode: null,
      });
    } else {
      this.formGroup.patchValue({
        billing_country: null,
      });
    }
  }

  manageExternalSiteResidence() {
    this.isCopingResidence = false;
    if (this.formGroup.value.external) {
      this.formGroup.patchValue({
        province_id: null,
        city_id: null,
        zipcode: null,
      });
    } else {
      this.formGroup.patchValue({
        country: null,
      });
    }
  }

  async save() {
    if (!this._authenticationService.hasCapability("edit_collaborator")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (this.formGroup.value.total_daily == 0 || this.formGroup.value.total_daily === "" || this.formGroup.value.total_daily === "0,00" || !this.formGroup.value.total_daily) {
      await this._utilService.showSWALError({ text: "ERROR_DAILY_COST_PRESUMED_EMPTY" });
      this.activeTab = "masterdata";
      return false;
    }
    //Controllo alert campi mancanti
    let keyToShowError: any = [];
    Object.keys(this.formGroup.controls).map((key) => {
      if (this.formGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });

    if (this.formGroup.invalid) {
      let textMessage = await this._utilService.translate("SOME_DATA_ARE_NOT_VALID");
      keyToShowError = await Promise.all(
        keyToShowError.map(async (key) => {
          key = await this._utilService.translate(key.toUpperCase());
          return key.toLowerCase();
        }),
      );
      keyToShowError.map((item, index: number = 0) => {
        index + 1 < keyToShowError.length ? (textMessage += item += ", ") : (textMessage += item += ".");
      });
      this.activeTab = "masterdata";
      return this._utilService.showSWALEmptyField({ text: textMessage });
    }
    //Indirizzi sono facoltativi ma controlliamo se almeno un campo è inserito tutti gli altri devono essere completi
    if (!this.formGroup.value.external) {
      if (!!this.formGroup.value.street || !!this.formGroup.value.city_id || !!this.formGroup.value.zipcode || !!this.formGroup.value.province_id) {
        if (!this.formGroup.value.street || !this.formGroup.value.city_id || !this.formGroup.value.zipcode || !this.formGroup.value.province_id) {
          await this._utilService.showSWALError({ text: "ERROR_RESIDENCE_ADDRESS_INCOMPLETED" });
          return false;
        }
      }
    } else {
      if (!!this.formGroup.value.street || !!this.formGroup.value.country) {
        if (!this.formGroup.value.street || !this.formGroup.value.country) {
          await this._utilService.showSWALError({ text: "ERROR_RESIDENCE_ADDRESS_INCOMPLETED" });
          return false;
        }
      }
    }
    if (!this.formGroup.value.billing_external) {
      if (!!this.formGroup.value.billing_street || !!this.formGroup.value.billing_city || !!this.formGroup.value.billing_zipcode || !!this.formGroup.value.billing_province) {
        if (!this.formGroup.value.billing_street || !this.formGroup.value.billing_city || !this.formGroup.value.billing_zipcode || !this.formGroup.value.billing_province) {
          await this._utilService.showSWALError({ text: "ERROR_BILLING_ADDRESS_INCOMPLETED" });
          return false;
        }
      }
    } else {
      if (!!this.formGroup.value.billing_street || !!this.formGroup.value.billing_country) {
        if (!this.formGroup.value.billing_street || !this.formGroup.value.billing_country) {
          await this._utilService.showSWALError({ text: "ERROR_BILLING_ADDRESS_INCOMPLETED" });
          return false;
        }
      }
    }
    this._utilService.showLoading();
    let data: Collaborator = {
      firstname: this.formGroup.value.firstname,
      lastname: this.formGroup.value.lastname,
      phone: this.formGroup.value.phone,
      private_email: this.formGroup.value.private_email,
      provider_id: this.formGroup.value.provider_id,
      type: this.formGroup.value.type === "Stagista" ? "stage" : this.formGroup.value.type === "Partita iva" ? "collaborator" : this.formGroup.value.type === "Da fornitore" ? "by-provider" : "occasional",
      fiscalcode: this.formGroup.value.fiscalcode,
      sex: this.formGroup.value.sex,
      badge_number: this.formGroup.value.badge_number,
      birthday: this.formGroup.value.birthday,
      email: this.formGroup.value.email,
      business_name: this.formGroup.value.business_name,
      figure_id: this.formGroup.value.figure_id,
      vat_number: this.formGroup.value.vat_number,
      unique_code: this.formGroup.value.unique_code,
      pec: this.formGroup.value.pec,
      note: this.formGroup.value.note,
      addresses: {},
      contract: {
        total_daily: this.formGroup.value.total_daily,
        start_date: this.formGroup.value.start_date,
        end_date: this.formGroup.value.end_date,
        tutor_hash: this.formGroup.value.tutor_hash,
      },
    };
    if (this.formGroup.value.street && this.formGroup.value.street.length > 0) {
      data.addresses.residenza = {
        street: this.formGroup.value.street,
        city_id: this.formGroup.value.city_id,
        zipcode: this.formGroup.value.zipcode,
        province_id: this.formGroup.value.province_id,
        country: this.formGroup.value.country,
      };
    }
    if (this.formGroup.value.billing_street && this.formGroup.value.billing_street.length > 0) {
      data.addresses.fatturazione = {
        street: this.formGroup.value.billing_street,
        city_id: this.formGroup.value.billing_city,
        zipcode: this.formGroup.value.billing_zipcode,
        province_id: this.formGroup.value.billing_province,
        country: this.formGroup.value.billing_country,
      };
    }
    await this._collaboratorsService
      .updateCollaborator(this.currentCollaboratorHash, data)
      .then(async () => {
        if (this.formGroup.value.send_welcome_email) {
          await this._collaboratorsService.enableLogin(this.currentCollaboratorHash);
        }
        await this.loadUserData();
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_COLLABORATOR" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_EDIT_COLLABORATOR" });
      });
  }

  async deleteAttachment(id: number) {
    if (!this._authenticationService.hasCapability("manage_collaborator_attachments")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this._utilService
      .showSWAL({
        title: "CONFIRM_DELETE_FILE",
        icon: "warning",
        confirmButtonText: "CONFIRM_DELETE_BTN",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      })
      .then(async (result) => {
        if (result.value) {
          await this._collaboratorsService
            .deleteCollaboratorAttachment(String(id))
            .then(async () => {
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_FILE" });
              this.currentCollaborator.contract_attachments = this.currentCollaborator.contract_attachments.filter((attachment) => attachment.id_attachment !== id);
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_DELETE_FILE" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
  }
}
